module.exports = __webpack_public_path__ + "static/media/22ESCWA5.74f9730e.jpg";